 export const environment = {
  production: false,
  environmentTitle: 'DEV',
  azureClientId: '98023153-546a-438c-9d18-e6d262d1e68b',
  awsApiUrlatlas:'https://atlas-atlas-api-dev.duke-energy.app/',
  azureApiScope: 'https://dukeenergy.onmicrosoft.com/98023153-546a-438c-9d18-e6d262d1e68b/api.read.write'
};